// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.17.42
import './legacy.mjs';
export { Client, ColyseusSDK } from './Client.mjs';
export { Room } from './Room.mjs';
export { Auth } from './Auth.mjs';
export { AbortError, MatchMakeError, ServerError } from './errors/Errors.mjs';
export { CloseCode, ErrorCode, Protocol } from '@colyseus/shared-types';
import { SchemaSerializer } from './serializer/SchemaSerializer.mjs';
export { getStateCallbacks } from './serializer/SchemaSerializer.mjs';
import { NoneSerializer } from './serializer/NoneSerializer.mjs';
import { registerSerializer } from './serializer/Serializer.mjs';
export { Callbacks } from '@colyseus/schema';

registerSerializer('schema', SchemaSerializer);
registerSerializer('none', NoneSerializer);

export { SchemaSerializer, registerSerializer };
//# sourceMappingURL=index.mjs.map
